
<nz-spin [nzSpinning]="isSpinning" [nzTip]="progress">
    <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="12">
            <form nz-row [nzGutter]="16" nz-form [formGroup]="formGroup" [nzLayout]="'vertical'" (ngSubmit)="onSubmit()">
                <mit-nz-form-item nz-col [nzSpan]="24" [label]="'Image File'" [required]="true">
                    <app-mit-uploader [formCtrl]="formGroup.get('imageTo3dUrl')" [showPreviewImage]="true" [accept]="'image/png, image/jpeg'"></app-mit-uploader>
                </mit-nz-form-item>
                <mit-nz-form-item nz-col [nzSpan]="24" [label]="'Topology'" [required]="true">
                    <nz-radio-group formControlName="topology">
                        <label *ngFor="let item of Topology" nz-radio [nzValue]="item">{{item}}</label>
                      </nz-radio-group>
                </mit-nz-form-item>
                <mit-nz-form-item nz-col [nzSpan]="24" [label]="'Art Style'" [required]="true">
                    <nz-radio-group formControlName="artStyle">
                        <label *ngFor="let item of ArtStyle" nz-radio [nzValue]="item">{{item}}</label>
                      </nz-radio-group>
                </mit-nz-form-item>
                <mit-nz-form-item nz-col [nzSpan]="24" [label]="'Target Poly Count'" [required]="true">
                    <nz-input-number formControlName="targetPolycount" [nzSize]="'large'" [nzMin]="10000" [nzMax]="30000" [nzPrecision]="0"></nz-input-number>
                </mit-nz-form-item>
                <button nz-button nzType="primary" type="submit">Generate 3D file</button>
            </form>
        </div>
        <div *ngIf="finalResult"  nz-col [nzSpan]="12">
            <img
                nz-image
                width="260px"
                height="260px"
                [nzSrc]="finalResult?.thumbnailUrl"
                alt=""
          />
          <div style="padding-top: 10px;">
            <button nz-button nzType="default" type="button" (click)="showDetail()" style="margin-right: 5px;">View Detail</button>
            <button nz-button nzType="primary" type="button" (click)="showCreateAsset()">Create Asset By This Glb</button>
          </div>
        </div>
    </div>
</nz-spin>

